var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgButtonBug = function SvgButtonBug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 50,
    height: 50,
    preserveAspectRatio: "none",
    viewBox: "0 0 50 50"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFCE41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.4 19.6-5.5 5.7.3 8.7 5 5 7.5 2.1 1-23.6zM34.5 19.6l5.4 9.8-5.4 9.9s-7.2 2.4-7.4 2.4L26 17.4zM32.7 17l-4.5-6h-6.4L18 17.1l7.7-1.9zM26.1 10h1l4.8-5.3h-2.4zM23.7 10h-.9l-3.6-5.3h2.6zM12.5 20.8l-1.3 1.3s-6.4-3.8-6.4-3.9 3-1.7 3-1.7zM9.2 29.3l.1 1.5-5.1 1.4-.9-3.3zM14.5 39.9l.7.7.6.1-2.1 4.6-3.1-1.8zM37.5 20.9l.9 1.5 6.4-2.1-1.5-2.8zM41.6 28.6l.3.8-.3.7 4.6 1.4.5-2.9zM37.6 37.4l-.8 1.6 2.6 4.5 2.5-1.3z"
  }))));
};
export default SvgButtonBug;